import { makeStyles } from "@material-ui/core"
import { useCalendarEventMutations } from "../hooks/use-calendar-event-mutations"
import InlineEditableText from "../../components/InlineEditableText"
import { CalendarEventViewModel } from "../api/calendar-event"
import { useSnackbar } from "notistack"
import { useTranslation } from "react-i18next"

const CalendarEventCardTitle = ({ calendarEvent }: { calendarEvent: CalendarEventViewModel }) => {
  const classes = useStyles()
  const calendarEventActions = useCalendarEventMutations()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation("calendarEvent")
  return (
    <InlineEditableText
      value={calendarEvent.title}
      onSave={(title) => {
        if (!title.trim()) {
          enqueueSnackbar(t("calendarEventDetails.titleCannotBeEmptyErrorMessage"), { variant: "error" })
          return
        }
        calendarEventActions.updateInfo(calendarEvent.id, { title })
      }}
      TypographyProps={{ variant: "h5", className: classes.todoTitle }}
      isEditable={calendarEvent.canUpdate}
    />
  )
}

const useStyles = makeStyles(() => ({
  todoTitle: {
    "& span, & textarea": {
      maxWidth: "none",
    },
  },
}))

export default CalendarEventCardTitle
